import {
  HIDE_RESCHEDULE_TRANSITION_MODAL,
  RECEIVE_QUESTIONNAIRE_LINKS,
  RECEIVE_TIMELINE_EVENTS,
  REQUEST_TIMELINE_EVENTS,
  REQUEST_TIMELINE_EVENTS_FAILED,
  SET_SHOW_PAST_EVENTS,
  SHOW_RESCHEDULE_TRANSITION_MODAL,
  TOGGLE_PAST_EVENTS,
  SHOW_MORE_PAST_EVENTS,
  SHOW_TIMELINE_MODAL,
  HIDE_TIMELINE_MODAL,
  ASSIGN_QUESTIONNAIRE_FAILED,
  ASSIGN_QUESTIONNAIRE_SUCCESS,
  ASSIGN_QUESTIONNAIRE,
} from './actions';
import { getTime } from '../../../utils/TimeUtils';

const initialState = {
  isFetching: false,
  lastFetch: null,
  error: null,
  assignError: null,
  data: [],
  showPastEvents: true,
  showRescheduleTransitionModalForNotification: false,
  pastEventsToRender: 10,
  timelineModalIsVisible: false,
};

export const timelineReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_TIMELINE_EVENTS:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case REQUEST_TIMELINE_EVENTS_FAILED:
      return {
        ...state,
        isFetching: false,
        data: [],
        error: action.error,
      };
    case RECEIVE_TIMELINE_EVENTS:
      return {
        ...state,
        isFetching: false,
        data: action.data,
        lastFetch: getTime(),
      };
    case TOGGLE_PAST_EVENTS:
      return {
        ...state,
        showPastEvents: !state.showPastEvents,
      };
    case SET_SHOW_PAST_EVENTS:
      return {
        ...state,
        showPastEvents: action.value,
      };
    case SHOW_RESCHEDULE_TRANSITION_MODAL:
      return {
        ...state,
        showRescheduleTransitionModalForNotification: action.notificationId,
      };
    case HIDE_RESCHEDULE_TRANSITION_MODAL:
      return {
        ...state,
        showRescheduleTransitionModalForNotification: false,
      };
    case SHOW_TIMELINE_MODAL:
      return {
        ...state,
        timelineModalIsVisible: true,
      };
    case HIDE_TIMELINE_MODAL:
      return {
        ...state,
        timelineModalIsVisible: false,
      };
    /*case RECEIVE_QUESTIONNAIRE_LINKS:
      return {
        ...state,
        questionnaireLinks: action.data
      };*/
    case SHOW_MORE_PAST_EVENTS:
      return {
        ...state,
        pastEventsToRender: state.pastEventsToRender + 10,
      };

    case ASSIGN_QUESTIONNAIRE:
      return {
        ...state,
        isFetching: true,
      };
    case ASSIGN_QUESTIONNAIRE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        assignError: null,
      };
    case ASSIGN_QUESTIONNAIRE_FAILED:
      return {
        ...state,
        isFetching: false,
        assignError: action.error,
      };
    default:
      return state;
  }
};
